import { util } from '@/api/util';
import { getContactIMHelperInstance } from './contact_im_helper';
export class ContactDBTeam {
    constructor(ctx, base, search) {
        this.ctx = ctx;
        this.base = base;
        this.search = search;
    }
    async syncTeamList(params = {}, sendContactNotify, isSyncTeamList) {
        var _a;
        if (isSyncTeamList.value && params.force) {
            console.warn('[contact] syncAll force syncTeamList more times');
            return;
        }
        params.force && (isSyncTeamList.value = true);
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        console.log('[contact] syncTeamList', params);
        if (params.force) {
            try {
                await getContactIMHelperInstance().syncAllTeams(mainAccount);
            }
            catch (e) {
                console.error('[contact] syncTeamList force error', e);
            }
            isSyncTeamList.value = false;
            sendContactNotify({ syncStatus: { team: true }, _account: mainAccount });
            return;
        }
        try {
            const res = await this.getNeedUpdateTeamOrgList(params);
            if (res.needUpdateMemberTeamIdList.length) {
                const memberList = res.needUpdateTeamMemberList;
                const memberListRes = await this.teamMemberIntoTable(res.needUpdateMemberTeamIdList, memberList);
                memberListRes && console.log('[contact] updateMemberTeamIdList success teamIdList');
            }
            if (res.needDeleteTeamList.length) {
                const deleteTeamListRes = await this.base.deleteData({
                    tableName: this.ctx.contactUtil.orgTable,
                    list: res.needDeleteTeamList,
                    _account: mainAccount,
                });
                console.log('[contact] delete team list', deleteTeamListRes);
            }
            if (res.needUpdateTeamList.length) {
                const teamListRes = await this.teamIntoOrg(res.needUpdateTeamList);
                console.log('[contact] teamListIntoOrg', teamListRes);
            }
        }
        catch (e) {
            console.error('[contact] getNeedUpdateTeamOrgList error', e, params);
        }
    }
    async getTeamServerData() {
        var _a;
        let teams = [];
        try {
            const { data } = await this.ctx.httpApi.get(this.ctx.systemApi.getUrl('getTeamList'));
            if ((data === null || data === void 0 ? void 0 : data.success) && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.teams)) {
                teams = data.data.teams;
            }
        }
        catch (e) {
            console.error('[contact] getTeamServerData error', e);
        }
        return this.transServerTeamList(teams);
    }
    async getNeedUpdateTeamOrgList(params) {
        var _a;
        const { teamList = [], force } = params;
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        let list;
        let teamMemberMap = {};
        if (force) {
            const data = await this.getTeamServerData();
            list = data.teamList;
            teamMemberMap = data.teamMemberMap;
        }
        else {
            list = teamList;
        }
        if (!list.length) {
            return {
                needDeleteTeamList: [],
                needUpdateTeamList: [],
                needUpdateMemberTeamIdList: [],
                needUpdateTeamMemberList: [],
            };
        }
        const orgList = this.transTeamToOrg(list);
        const newIdList = util.getKeyListByList(orgList, 'id');
        let oldTeamList;
        if (force) {
            oldTeamList = await this.getTeamOrgList();
        }
        else {
            oldTeamList = await this.search.getOrgList({ idList: newIdList, _account: mainAccount });
        }
        const oldTeamMap = util.listToMap(oldTeamList, 'id');
        const needUpdateTeamList = [];
        const needUpdateMemberTeamIdList = [];
        let needUpdateTeamMemberList = [];
        const oldIdList = util.getKeyListByList(oldTeamList, 'id');
        const diff = util.getDiff(oldIdList, newIdList);
        const needDeleteTeamList = diff.deleteDiff ? diff.deleteDiff : [];
        orgList.forEach(item => {
            const oldItem = oldTeamMap[item.id];
            const teamId = item.id.split('team_')[1];
            if (!force && oldItem) {
                if (item.updateTime > oldItem.updateTime) {
                    needUpdateTeamList.push(item);
                }
                if (item.memberUpdateTime > oldItem.memberUpdateTime) {
                    needUpdateMemberTeamIdList.push(teamId);
                    needUpdateTeamMemberList = needUpdateTeamMemberList.concat(teamMemberMap[teamId] || []);
                }
            }
            else {
                needUpdateTeamList.push(item);
                needUpdateMemberTeamIdList.push(teamId);
                needUpdateTeamMemberList = needUpdateTeamMemberList.concat(teamMemberMap[teamId] || []);
            }
        });
        return {
            needDeleteTeamList,
            needUpdateTeamList,
            needUpdateMemberTeamIdList,
            needUpdateTeamMemberList,
        };
    }
    transTeamToOrg(list) {
        const orgList = [];
        list.forEach(item => {
            const { teamId, serverCustom, avatar, intro, name, announcement, owner, memberNum, memberUpdateTime, createTime, updateTime } = item;
            const type = 2000;
            const id = 'team_' + teamId;
            const parent = 'team';
            const originId = 'team_' + teamId;
            const orgRank = createTime;
            let orgName = name || '';
            const visibleCode = 0;
            if (!orgName || orgName.includes('LINGXI_IM_TEAM_DEFAULT_NAME')) {
                try {
                    const customObj = JSON.parse(serverCustom);
                    orgName = customObj.auto_team_name || orgName;
                }
                catch (e) {
                    console.error('[contact] transTeamToOrg SON.parse serverCustom', e);
                }
            }
            const orgPYName = util.toPinyin(orgName);
            orgList.push({
                id,
                parent,
                orgName,
                orgPYName,
                orgRank,
                type,
                visibleCode,
                originId,
                avatar,
                intro,
                announcement,
                owner,
                memberNum,
                memberUpdateTime,
                createTime,
                updateTime,
                _lastUpdateTime: updateTime,
            });
        });
        return orgList;
    }
    transServerTeamMemberList(item) {
        const { tid: teamId, owner, admins, members } = item;
        let teamMember = [];
        teamMember = members.concat([
            Object.assign(Object.assign({}, owner), { type: 'owner' }),
            ...admins.map((adminMember) => (Object.assign(Object.assign({}, adminMember), { type: 'manage' }))),
        ]);
        return teamMember.map((memberItem) => {
            const { type, nick: nickInTeam, createtime: joinTime, accid: account } = memberItem;
            return {
                type: type || 'normal',
                nickInTeam,
                joinTime,
                teamId,
                account,
            };
        });
    }
    transServerTeamList(list) {
        const teamMemberMap = {};
        const teamList = list.map(item => {
            const { icon: avatar, intro, announcement, owner, member_update_time: memberUpdateTime, createtime: createTime, updatetime: updateTime, custom: serverCustom, tname: name, tid: teamId, } = item;
            const ownerId = owner.accid;
            const memberList = this.transServerTeamMemberList(item);
            teamMemberMap[teamId] = memberList;
            return {
                serverCustom,
                name,
                teamId,
                avatar,
                intro,
                announcement,
                owner: ownerId,
                memberNum: memberList.length,
                memberUpdateTime,
                createTime,
                updateTime,
            };
        });
        return {
            teamList,
            teamMemberMap,
        };
    }
    async transTeamMemberToOrgContact(list) {
        var _a;
        const yunxinIdList = new Set();
        const _lastUpdateTime = Date.now();
        list.forEach(item => {
            yunxinIdList.add(item.account);
        });
        const contactItemList = await this.search.getContactItemListByItem([...yunxinIdList]);
        const yunxinIdMap = {};
        contactItemList.forEach(item => {
            const yunxin = item.contactItemVal;
            if (item.type !== 'personal') {
                yunxinIdMap[yunxin] = item.contactId;
                yunxinIdList.delete(yunxin);
            }
        });
        if (yunxinIdList.size) {
            try {
                const { data } = await this.ctx.httpApi.post(this.ctx.systemApi.getUrl('getContactByYunxin'), { yunxinAccIdList: [...yunxinIdList] });
                const itemList = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.itemList;
                itemList === null || itemList === void 0 ? void 0 : itemList.forEach((element) => {
                    yunxinIdMap[element.yunxinAccountId] = element.qiyeAccountId;
                });
                console.log('[contact_dbl] syncTeam getContactByYunxin yunxinIdMap', yunxinIdMap);
            }
            catch (e) {
                console.error('[contact_dbl] syncTeam getContactByYunxin error', e);
            }
        }
        return list.map(item => {
            const { type, nickInTeam, joinTime, teamId, account: yunxinId } = item;
            const contactId = yunxinIdMap[yunxinId] || '';
            const orgId = 'team_' + teamId;
            const id = util.getUnique(orgId, yunxinId, contactId);
            const imId = orgId + '_' + yunxinId;
            return {
                id,
                imId,
                contactId,
                orgId,
                yunxinId,
                type,
                nickInTeam,
                joinTime,
                _lastUpdateTime,
            };
        });
    }
    teamIntoOrg(list) {
        var _a;
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.base.intoTable({
            tableName: this.ctx.contactUtil.orgTable,
            list,
            _account: mainAccount,
        });
    }
    async teamMemberIntoTable(teamIdList, list) {
        var _a;
        const teamOrgIdList = teamIdList.map(item => 'team_' + item);
        const teamMemberList = await this.transTeamMemberToOrgContact(list);
        const oldTeamMemberList = (await this.search.getOrgContactListByOrgId(teamOrgIdList, this.ctx.contactUtil.getCurrentAccount()));
        const teamMemberIdList = util.getKeyListByList(teamMemberList, 'id');
        const oldTeamMemberIdList = util.getKeyListByList(oldTeamMemberList, 'id');
        const diffRes = util.getDiff(oldTeamMemberIdList, teamMemberIdList);
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const { success, error } = await util.SyncCatchError(() => {
            const arr = [
                this.base.intoTable({
                    tableName: this.ctx.contactUtil.orgContactTable,
                    list: teamMemberList,
                    _account: mainAccount,
                }),
            ];
            if (diffRes.deleteDiff) {
                arr.push(this.base.deleteData({
                    tableName: this.ctx.contactUtil.orgContactTable,
                    list: diffRes.deleteDiff,
                    _account: mainAccount,
                }));
            }
            return Promise.all(arr);
        });
        if (!success && error) {
            console.error('[contact] teamMemberIntoTable', error, teamIdList, list);
        }
        return success;
    }
    getTeamListById(list) {
        var _a;
        const idList = list.map(item => (item.includes('team_') ? item : 'team_' + item));
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.search.getOrgList({ idList, _account: mainAccount });
    }
    async getTeamMemberById(idList) {
        var _a, _b;
        console.log('[contact] [team] getTeamMemberById start', idList);
        if (!idList.length)
            return [];
        let memberList = [];
        try {
            const ids = idList.join(',');
            const { data } = await this.ctx.httpApi.get(this.ctx.systemApi.getUrl('getTeamMembers'), { tid_list: ids });
            console.log('[contact] [team] getTeamMemberById end', data);
            if ((data === null || data === void 0 ? void 0 : data.success) && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length)) {
                (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.forEach((item) => {
                    memberList = memberList.concat(this.transServerTeamMemberList(item));
                });
            }
        }
        catch (e) {
            console.error('[contact] getTeamMemberById error', e);
        }
        return memberList;
    }
    async getTeamMemberByTeamIdAndAccount(teamId, accounts) {
        const memberList = await this.getTeamMemberById([teamId]);
        return memberList.filter(item => item.teamId === teamId && accounts.includes(item.account));
    }
    getTeamOrgList() {
        var _a;
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.search.getOrgList({ typeList: [2000], _account: mainAccount });
    }
    async handleLeaveTeam(team) {
        const orgId = 'team_' + team.teamId;
        const orgContactList = await this.search.getOrgContactList({
            idList: [orgId],
            type: 'orgId',
        });
        const idList = util.getKeyListByList(orgContactList, 'id');
        await this.base.deleteData({
            tableName: this.ctx.contactUtil.orgContactTable,
            list: idList,
        });
        await this.base.deleteData({
            tableName: this.ctx.contactUtil.orgTable,
            list: [orgId],
        });
    }
    async handleUpdateTeam(team) {
        const teamList = this.transTeamToOrg([team]);
        await this.teamIntoOrg(teamList);
    }
    async handleRemoveTeamMembers(team, accounts) {
        var _a;
        const teamId = 'team_' + team.teamId;
        const imIdList = accounts.map(item => teamId + '_' + item);
        const teamMemberList = await this.search.getOrgContactList({
            type: 'imId',
            idList: imIdList,
        });
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const idList = util.getKeyListByList(teamMemberList, 'id');
        await this.base.deleteData({
            tableName: this.ctx.contactUtil.orgContactTable,
            list: idList,
            _account: mainAccount,
        });
        const teamList = this.transTeamToOrg([team]);
        await this.base.intoTable({
            tableName: this.ctx.contactUtil.orgTable,
            list: teamList,
            _account: mainAccount,
        });
    }
    async handleTransferTeamMembers(team, accounts) {
        var _a;
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const teamMemberList = await this.getTeamMemberByTeamIdAndAccount(team.teamId, accounts);
        const memberList = await this.transTeamMemberToOrgContact(teamMemberList);
        await this.base.intoTable({
            tableName: this.ctx.contactUtil.orgContactTable,
            list: memberList,
            _account: mainAccount,
        });
        const teamList = this.transTeamToOrg([team]);
        await this.base.intoTable({
            tableName: this.ctx.contactUtil.orgTable,
            list: teamList,
            _account: mainAccount,
        });
    }
    async handleAddTeamMembers(team, accounts) {
        var _a;
        const mainAccount = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const teamMemberList = await this.getTeamMemberByTeamIdAndAccount(team.teamId, accounts);
        const memberList = await this.transTeamMemberToOrgContact(teamMemberList);
        await this.base.intoTable({
            tableName: this.ctx.contactUtil.orgContactTable,
            list: memberList,
            _account: mainAccount,
        });
        const teamList = this.transTeamToOrg([team]);
        await this.base.intoTable({
            tableName: this.ctx.contactUtil.orgTable,
            list: teamList,
            _account: mainAccount,
        });
    }
    async handleTeamEvent(res, sendContactNotify) {
        console.log('[contact] [team] action', res);
        await getContactIMHelperInstance().handleTeamEvent(res, sendContactNotify);
    }
}
